import PropTypes from 'prop-types';
import { Component } from 'react';
import EmailActionMetadata from 'automation-ui-action-features/actions/email/EmailActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import EmailActionDetail from 'automation-ui-action-features/actions/email/EmailActionDetail';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import { jsx as _jsx } from "react/jsx-runtime";
class EmailActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      actionLabel,
      flowObjectTypeId
    } = this.props;
    const content = /*#__PURE__*/_jsx(EmailActionDetail, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    });
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: content
    });
  }
}
EmailActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(EmailActionMetadata).isRequired,
  actionLabel: PropTypes.node,
  flowObjectTypeId: ObjectTypeIdType
};
export default EmailActionHistoryCard;